import {
  ICreateOrUpdateInboundData,
  useMutation,
  useQueryClient,
} from '@northladder/services';

import { WEEKLY_STATS_INFO_QUERY_KEY } from '../../inventory';

import { INBOUND_API } from '../../../inboundAPIClient';

import { INBOUND_SEARCH_LIST_KEY } from './useSearchInboundListQuery';
import { PENDENCY_REPORT_QUERY_KEY } from './usePendencyReportQuery';

/**
 * This is to track the create or update Inbound mutation keys in react query cache.
 */
const MUTATE_CREATE_OR_UPDATE_INBOUND = 'create-or-update-inbound-mutation-key';

interface IUseManageCreateOrUpdateMutation {
  onSuccessCallback?: (data: ICreateOrUpdateInboundData) => void;
}

/**
 * React Query mutation function for managing create or update Inbound api
 */
export const useManageCreateOrUpdateInboundMutation = ({
  onSuccessCallback,
}: IUseManageCreateOrUpdateMutation) => {
  const queryClient = useQueryClient();
  const {
    data,
    error,
    isError,
    isPending,
    mutate: createOrUpdateInbound,
    reset: resetCreateInboundMutation,
  } = useMutation({
    mutationKey: [MUTATE_CREATE_OR_UPDATE_INBOUND],
    networkMode: 'always',
    mutationFn: INBOUND_API.createOrUpdateInbound,
    onSuccess: (successData) => {
      queryClient.invalidateQueries({ queryKey: [INBOUND_SEARCH_LIST_KEY] });
      queryClient.invalidateQueries({ queryKey: [PENDENCY_REPORT_QUERY_KEY] });
      queryClient.invalidateQueries({
        queryKey: [WEEKLY_STATS_INFO_QUERY_KEY],
      });
      queryClient.refetchQueries({ queryKey: [WEEKLY_STATS_INFO_QUERY_KEY] });

      onSuccessCallback?.(successData);
    },
  });

  return {
    createOrUpdateInbound,
    data,
    error,
    isError,
    isPending,
    resetCreateInboundMutation,
  };
};
